import Swiper from 'swiper/bundle';

export function gallery() {
  const swiper = new Swiper(".js-gallery-thumbs", {
    allowTouchMove: false,
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
  });
  const swiper2 = new Swiper(".js-gallery-main", {
    effect: 'fade',
    allowTouchMove: false,
    spaceBetween: 10,
    thumbs: {
      swiper: swiper,
    },
  });
}
